const checkboxTokens = ({ borders, fontSizeBody, sizes, space, colors }) => ({
  borders: borders[1],
  colors: {
    labelColor: colors.neutrals[3],
    hover: {
      default: colors.brandPrimary['50'],
      variant: colors.positive.dark,
    },
    default: {
      borderColor: colors.neutrals[5],
      iconColor: colors.white,
      bgColor: colors.white,
    },
    checked: {
      borderColor: colors.primary['50'],
      iconColor: colors.white,
      bgColor: colors.primary['50'],
    },
    error: {
      borderColor: colors.negative.default,
      iconColor: colors.negative.default,
      bgColor: colors.negative.lightest,
      labelColor: colors.neutrals[3],
    },
    disabled: {
      borderColor: colors.neutrals[6],
      iconColor: colors.neutrals[5],
      bgColor: colors.neutrals[7],
    },
    variant: {
      borderColor: colors.positive.dark,
      iconColor: colors.white,
      bgColor: colors.positive.dark,
    },
  },
  space: {
    fromLabel: space['1x_small'],
  },
  sizes: {
    minWidth: sizes[1],
    height: sizes[1],
  },
  lineHeight: '24px',
  fontSizes: fontSizeBody[2],
  opacity: {
    disabled: 1,
  },
});

export default checkboxTokens;
